import { render, staticRenderFns } from "./DemandsTab.vue?vue&type=template&id=7b6bd38e&scoped=true"
import script from "./DemandsTab.vue?vue&type=script&lang=js"
export * from "./DemandsTab.vue?vue&type=script&lang=js"
import style0 from "./DemandsTab.vue?vue&type=style&index=0&id=7b6bd38e&prod&lang=scss"
import style1 from "./DemandsTab.vue?vue&type=style&index=1&id=7b6bd38e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6bd38e",
  null
  
)

export default component.exports